import LeaderboardNameCell from './LeaderboardNameCell';

export default LeaderboardNameCell;
